import BasicService from "./BasicService";

class ReportService extends BasicService {
  constructor() {
    super();
  }

  /**
   *
   * @param {Date} fromDate
   * @param {Date} toDate
   * @param {String} action - to, from
   * @param {Number} cityId - id 0 for all city
   * @param {Number} branchId - id 0 for all branch
   * @param {Number} townshipId - id 0 for all township
   * @param {String} type - date, month, year
   */
  getCompletReport(
    fromDate,
    toDate,
    action,
    cityId,
    branchId,
    townshipId,
    type
  ) {
    let url = `/report/complete`;

    return this.axios
      .get(url, {
        params: {
          fromDate,
          toDate,
          action,
          cityId,
          branchId,
          townshipId,
          type
        }
      })
      .then(request => request.data);
  }

  /**
   *
   * @param {*} date - Date is Title Date
   * @param {*} action - to, from
   * @param {*} cityId - id 0 for all city
   * @param {*} branchId - id 0 for all branch
   * @param {*} townshipId - id 0 for all township
   * @param {*} type - date, month, year
   * @param {*} userId - employee id
   */
  getCompletDetailReport(
    date,
    action,
    cityId,
    branchId,
    townshipId,
    type,
    userId
  ) {
    let url = `/report/completeDetail`;
    return this.axios
      .get(url, {
        params: {
          date,
          action,
          cityId,
          branchId,
          townshipId,
          type,
          userId
        }
      })
      .then(request => request.data);
  }

  getSaleReport(fromDate, toDate, cityId, branchId, townshipId, type) {
    let url = `/report/sale`;
    return this.axios(url, {
      params: {
        fromDate,
        toDate,
        cityId,
        branchId,
        townshipId,
        type
      }
    }).then(response => response.data);
  }

  getRiderTimeReport(fromDate, toDate, userAccountId, status) {
    let url = "/report/ridertime";
    return this.axios
      .get(url, {
        params: {
          fromDate,
          toDate,
          userAccountId,
          status
        }
      })
      .then(response => response.data);
  }
  getRiderAnalyzeReport(fromDate, toDate, riderId, osId, type) {
    let url = "/report/rideranalyze";
    return this.axios
      .get(url, {
        params: {
          fromDate,
          toDate,
          riderId,
          osId,type
        }
      })
      .then(response => response.data);
  }
  getRestAnalyzeReport(fromDate, toDate,osId, status) {
    let url = "/report/restanalyze";
    return this.axios
      .get(url, {
        params: {
          fromDate, toDate,
          osId,
          status
        }
      })
      .then(response => response.data);
  }

  getRestAnalyzeDetailReport(fromDate, toDate,osId) {
    let url = `/report/restanalyzedetail`;
    return this.axios
      .get(url, {
        params: {
          fromDate, toDate,
          osId
        }
      })
      .then(request => request.data);
  }
  

  getSaleDetailReport(date, cityId, branchId, townshipId, type, osId) {
    let url = `/report/saleDetail`;
    return this.axios
      .get(url, {
        params: {
          date,
          cityId,
          branchId,
          townshipId,
          type,
          osId
        }
      })
      .then(request => request.data);
  }



  processListDeliveryDownload(
    type,
    fromDate,
    toDate,
    userAccountId,
    osId,
    fromBranch,
    toBranch, dateChange) {
    return this.axios({
      url: "/excels/deliverys",
      method: "GET",
      responseType: "blob",
      params: {
        type,
        fromDate,
        toDate,
        userAccountId,
        osId,
        fromBranch,
        toBranch,dateChange
      } // important
    });
  }

  processListDownload(type,
    fromDate,
    toDate,
    userAccountId,
    osId,
    fromBranch,
    toBranch,dateChange) {
    return this.axios({
      url: "/excels/deliverys/type",
      method: "GET",
      responseType: "blob",
      params: {
        type,
        fromDate,
        toDate,
        userAccountId,
        osId,
        fromBranch,
        toBranch,dateChange
      }
    });
  }
  freeDailyRider(fromDate,toDate,riderId,type) {
    return this.axios({
      url: "/free/dailyrider",
      method: "GET",
      responseType: "blob",
      params: {
        fromDate,toDate,riderId,type
      }
    });
  }
  freeDailyRestaurant(fromDate,toDate,restaurantId,riderId) {
    return this.axios({
      url: "/free/dailyrestaurant",
      method: "GET",
      responseType: "blob",
      params: {
        fromDate,toDate,restaurantId,riderId
      }
    });
  }
  freeDailyriderpayment(fromDate,toDate,riderId) {
    return this.axios({
      url: "/free/dailyriderpayment",
      method: "GET",
      responseType: "blob",
      params: {
        fromDate,toDate,riderId
      }
    });
  }
  getFinanceByRemark(receivedDate,riderId,remark) {
    let url = `/finance/remark`;
    return this.axios.get(url,{
      params:{
        receivedDate,riderId,remark
      }
    }).then(response => response.data);
  }
}

const reportService = new ReportService();
export default reportService;
